import React, { useState } from "react";
import GlassCard from "./GlassCard";
import faqs from "../data/faqs";

const FAQ = ({ lang = "sl" }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const items = faqs[lang] || faqs.sl;

  const heading =
    lang === "en" ? "Frequently Asked Questions" : "Pogosto zastavljena vprašanja";
  const intro =
    lang === "en"
      ? "Got questions? We’ve got answers. Find everything you need to know about our online physiotherapy services."
      : "Imate vprašanja? Tukaj najdete odgovore na najpogostejša vprašanja o naši spletni fizioterapiji.";

  return (
    <section>
      <div className="container" style={{ maxWidth: 1040 }}>

        <h1></h1>
        <h1></h1>
        <GlassCard
          style={{
            padding: 24,
            borderRadius: 32,
          }}
        >
          <h2
          style={{
            textAlign: "center",
            marginBottom: 8,
            color: "#176B87",
            fontSize: 28,
          }}
        >
          {heading}
        </h2>
        <p
          style={{
            textAlign: "center",
            marginBottom: 32,
            color: "var(--text-muted)",
          }}
        >
          {intro}
        </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {items.map((item, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div
                  key={idx}
                  style={{
                    borderRadius: 20,
                    background: "rgba(255,255,255,0.85)",
                    overflow: "hidden",
                    transition: "background 0.2s ease",
                  }}
                >
                  <button
                    onClick={() =>
                      setOpenIndex(isOpen ? null : idx)
                    }
                    style={{
                      width: "100%",
                      padding: "18px 24px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      fontWeight: 600,
                      background: "transparent",
                    }}
                  >
                    <span>{item.question}</span>
                    <span style={{ fontSize: 20 }}>
                      {isOpen ? "▴" : "▾"}
                    </span>
                  </button>
                  {isOpen && (
                    <div
                      style={{
                        padding: "0 24px 18px",
                        color: "var(--text-muted)",
                        fontSize: 14,
                      }}
                    >
                      {item.answer}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </GlassCard>
      </div>
    </section>
  );
};

export default FAQ;
